import { useEffect, useRef, useState } from "react";

import { BoardroomScreen } from "./Components/BoardroomScreen";
import CryptoJS from "crypto-js";

import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
  // useNavigate,
} from "react-router-dom";

import agent1 from "./assets/agent1.png";
import agent2 from "./assets/agent2.png";
import agent3 from "./assets/agent3.png";
import agent4 from "./assets/agent4.png";
import agent5 from "./assets/agent5.png";
import agent6 from "./assets/agent6.png";
import "./App.css";
import BoardroomAccessView from "./Components/BoardroomAccessView";
// import AuthProvider from "./Components/AuthProvider";
import SelectionPage from "./Components/SelectionPage";
import axios from "axios";
import ProtectedRoute from "./Components/ProtectedRoute";
import OAuthLogin from "./Components/OAuthLogin";
import SelectedAgent from "./pages/SelectAgent";
// import axios from "axios";

// Button component directly included
function Button({
  className,
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}) {
  const Comp = asChild ? "span" : "button";

  const baseStyles =
    "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-blue-500 focus-visible:ring-2 focus-visible:ring-blue-500/50";

  const variantStyles = {
    default: "bg-blue-500 text-white hover:bg-blue-600",
    destructive: "bg-red-500 text-white hover:bg-red-600",
    outline: "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50",
    secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300",
    ghost: "hover:bg-gray-100 hover:text-gray-900",
    link: "text-blue-500 underline-offset-4 hover:underline",
  };

  const sizeStyles = {
    default: "h-9 px-4 py-2",
    sm: "h-8 rounded-md px-3 text-xs",
    lg: "h-10 rounded-md px-6",
    icon: "w-9 h-9 rounded-md",
  };

  const buttonClass = `${baseStyles} ${variantStyles[variant]} ${
    sizeStyles[size]
  } ${className || ""}`;

  return <Comp className={buttonClass} {...props} />;
}

// Mock data for 20 AI agents
export const mockAgents = [
  {
    id: "1",
    name: "Charlotte",
    title: "Executive Secretary",
    image: agent1,
    imageSitting: "/Charlotte-sitting.png",
  },
  {
    id: "2",
    name: "Ethan",
    title: "Chief Technology Officer",
    image: agent2,
    imageSitting: "/Ethan-setting.png",
  },
  {
    id: "4",
    name: "Alex",
    title: "Executive Secretary",
    image: agent4,
    imageSitting: "/Maxwell-sitting.png",
  },
  {
    id: "7",
    name: "Sterling",
    description: "Assistant",
    activeAgentType: "legal_assistant",

    title: "Chief Technology Officer",
    image: agent6,
    imageSitting: "/sterling-sitting.png",
  },
  {
    id: "3",
    name: "Elena",
    title: "Chief Financial Officer",
    image: agent3,
    imageSitting: "/Elena-sitting.png",
  },

  {
    id: "5",
    name: "Sloane",
    title: "Executive Secretary",
    image: agent5,
    imageSitting: "/Salone-sitting.png",
  },
];

// const API_BASE_URL = "https://boardroom.tide360.ai";
const API_BASE_URL = process.env.REACT_APP__API_BASE_URL;

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const decryptAES = (encryptedBase64, key) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key);
    const str = decrypted.toString(CryptoJS.enc.Utf8);
    return str.length > 0 ? JSON.parse(str) : null;
  } catch (e) {
    console.error("AES decryption failed:", e);
    return null;
  }
};

export default function App() {
  const [userDetails, setUserDetails] = useState(null);
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [magicCode, setMagicCode] = useState("");
  const [stepParam, setStepParam] = useState(null);
  const [fallBackDetails, setFallBackDetails] = useState(null);
  const intervalRef = useRef(null);
  const storedMagicCode = localStorage.getItem("magicCode");

  const [loading, setLoading] = useState(true);

  //const magicCode = window.location.pathname.split('/')[2];
  const magicCodeDefault = "PX6XIH";

  // function getMagicCodeFromPath() {
  //   const segments = window.location.pathname.split("/").filter(Boolean);
  //   const chatIndex = segments.indexOf("chat");

  //   if (chatIndex !== -1 && segments.length > chatIndex + 1) {
  //     return segments[chatIndex + 1]; // This is the `magicCode`
  //   }

  //   return null; // Fallback if route is unexpected
  // }
  // useEffect(() => {
  //  const response = getMagicCodeFromPath();
  //  setMagicCode(response);
  // }, []);

  const handleGHLUserData = async (payload) => {
    console.log("Encrypted payload received:", payload);
    const decrypted = decryptAES(payload, SECRET_KEY);
    console.log("Decrypted user data:", decrypted);

    if (!decrypted?.userId) {
      setStepParam(1);
      setLoading(false);
      return;
    }

    if (!decrypted?.activeLocation) {
      alert(
        "No sub account location found. Ask your admin to add at least 1 location."
      );
    }

    setUserId(decrypted.userId);
    setFallBackDetails(decrypted);

    try {
      const csrfToken =
        document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content") || "";

      const formData = new FormData();
      formData.append("user_id", decrypted.userId);
      formData.append("location_id", decrypted.activeLocation ?? "");

      const response = await axios.post(
        `${API_BASE_URL}/api/check-auth`,
        formData,
        {
          headers: { "X-CSRF-TOKEN": csrfToken },
        }
      );

      if (response.data?.user) {
        setUser(response.data.user);
      } else {
        setStepParam(response.data?.step ?? 1);
      }
    } catch (err) {
      console.error("Auth API error:", err);
      setStepParam(1);
    } finally {
      setLoading(false);
    }
  };
  const requestUserContext = () => {
    console.log("Requesting fresh GHL user context...");
    window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
  };

  const authenticateUser = () => {
    requestUserContext(); // ask GHL for fresh context
  };
  const checkAuthenticationStatus = () => {
    if (intervalRef.current) return;

    intervalRef.current = setInterval(() => {
      requestUserContext();
    }, 5000);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.data.message === "REQUEST_USER_DATA_RESPONSE" &&
        event.data.payload
      ) {
        handleGHLUserData(event.data.payload);
      }
    };

    window.addEventListener("message", handleMessage);
    authenticateUser(); // initial load

    return () => window.removeEventListener("message", handleMessage);
  }, []);
  const fetchUserDetails = async () => {
    // if (magicCode !== "") {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/oauth/user/details/${storedMagicCode}`
      );

      if (res.data && res.data.user_id && res.data.email) {
        setUserDetails(res.data);
      } else {
        // window.location.href = `${API_BASE_URL}/app?error=Access Denied!`;
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      // window.location.href = `${API_BASE_URL}/app?error=Access Denied!`;
    } finally {
      setLoading(false);
    }
    // }
  };

  useEffect(() => {
    fetchUserDetails();
  }, [storedMagicCode]);

  console.log("user", user);
  const getAccessBoardroomUrl = () => {
    if (!user?.magic_code)
      return `${API_BASE_URL}/app?error=Access Denied, Try again!`;

    // return `${window.location.origin}/#/select-agent/chat/N4J8QE`;
    return `${window.location.origin}/#/select-agent/chat/${user.magic_code}`;
  };
  // if (loading) return <div>Loading...</div>;
  // if (stepParam !== null) {
  //   return (
  //     <OAuthLogin
  //       stepParam={stepParam}
  //       checkAuthenticationStatus={checkAuthenticationStatus}
  //       userId={userId}
  //     />
  //   );
  // }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            stepParam !== null ? (
              <OAuthLogin
                stepParam={stepParam}
                checkAuthenticationStatus={checkAuthenticationStatus}
                userId={userId}
              />
            ) : (
              <BoardroomAccessView link={getAccessBoardroomUrl()} />
            )
          }
        />
        <Route
          path="/select-agent/chat/:magicCode"
          element={
            <SelectedAgent
              setMagicCode={setMagicCode}
              magicCode={magicCode}
              userDetails={userDetails}
            />
            // <SelectionPage
            //   setMagicCode={setMagicCode}
            //   magicCode={magicCode}
            //   userDetails={userDetails}
            // />
          }
        />

        <Route
          path="/boardroom"
          element={
            // <ProtectedRoute userDetails={userDetails}>
            <BoardroomScreen
              userDetails={userDetails}
              magicCode={magicCode}
              API_BASE_URL={API_BASE_URL}
              setUserDetails={setUserDetails}
              setMagicCode={setMagicCode}
            />
            // </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
